import { buildModelManager } from "../builder.js";
const DefaultDocumentProcessorConfigSelection = {
  __typename: true,
  id: true,
  accessLevel: true,
  aiParameters: true,
  allowedFileTypes: true,
  authorizedUsers: true,
  completionsConfig: true,
  completionsEndpoint: true,
  configId: true,
  createdAt: true,
  createdById: true,
  description: { markdown: true, truncatedHTML: true },
  detectedFields: true,
  fieldDefinitionMethod: true,
  fieldExtractionMethod: true,
  fieldInputConfig: true,
  generatedPrompt: { markdown: true, truncatedHTML: true },
  inputMethod: true,
  institution: true,
  isActive: true,
  lastUsed: true,
  name: true,
  openAiVectorStoreId: true,
  processingGoal: { markdown: true, truncatedHTML: true },
  referenceFiles: true,
  templateDocument: { url: true, mimeType: true, fileName: true },
  updatedAt: true,
  usageCount: true,
  vectorStoreId: true
};
const modelApiIdentifier = "documentProcessorConfig";
const pluralModelApiIdentifier = "documentProcessorConfigs";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByConfigId",
    findByField: "configId",
    findByVariableName: "configId",
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByConfigId",
    findByField: "configId",
    findByVariableName: "configId",
    modelApiIdentifier,
    defaultSelection: DefaultDocumentProcessorConfigSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createDocumentProcessorConfig",
    operationReturnType: "CreateDocumentProcessorConfig",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      documentProcessorConfig: { required: false, type: "CreateDocumentProcessorConfigInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "action",
    operationName: "bulkCreateDocumentProcessorConfigs",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateDocumentProcessorConfigsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "action",
    operationName: "updateDocumentProcessorConfig",
    operationReturnType: "UpdateDocumentProcessorConfig",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      documentProcessorConfig: { required: false, type: "UpdateDocumentProcessorConfigInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateDocumentProcessorConfigs",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateDocumentProcessorConfigsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "action",
    operationName: "deleteDocumentProcessorConfig",
    operationReturnType: "DeleteDocumentProcessorConfig",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteDocumentProcessorConfigs",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertDocumentProcessorConfig",
    operationReturnType: "UpsertDocumentProcessorConfig",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      documentProcessorConfig: { required: false, type: "UpsertDocumentProcessorConfigInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateDocumentProcessorConfigResult": { hasReturnType: false },
      "... on UpdateDocumentProcessorConfigResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertDocumentProcessorConfigs",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertDocumentProcessorConfigsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultDocumentProcessorConfigSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "documentProcessorConfigGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const DocumentProcessorConfigManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultDocumentProcessorConfigSelection,
  operations
);
export {
  DefaultDocumentProcessorConfigSelection,
  DocumentProcessorConfigManager
};
//# sourceMappingURL=DocumentProcessorConfig.js.map
